import React, { Fragment, useEffect, useState } from 'react'
import './style.sass'
import { useDispatch, useSelector } from 'react-redux'
import SectionHeader from '../../../common/SectionHeader'
import Table from '../../../common/Table'
import SearchField from '../../../common/SearchField'
import LoadingBlock from '../../../common/LoadingBlock'
import { getAllApplications } from '../../../../redux/actions/application'
import { useHistory } from 'react-router'
import ApplicationStatus from '../../../../constants/ApplicationStatus'
import AppListErrorState from './components/AppListErrorState'
import AppListEmptyState from './components/AppListEmptyState'
import IconTitle from '../../../common/IconTitle'

const headers = [
  'App Name',
  'Live Version',
  'Latest Approved Version',
  'Type'
]

const AllApplications = () => {
  // ==== Local state ====
  const [filterText, setFilterText] = useState('')

  const history = useHistory()
  const dispatch = useDispatch()

  const appList = useSelector(({ application }) => application.appList)
  const fetchingAppList = useSelector(({ application }) => application.fetchingAppList)
  const errorFetchingAppList = useSelector(({ application }) => application.errorFetchingAppList)

  // ==== Get data ====
  useEffect(() => {
    dispatch(getAllApplications())
  }, [])

  // ==== Methods ====
  const generateTableRows = () => {
    const filteredApps = getFilteredApps()
    return filteredApps.map(a => ({
      orignal: a,
      data: [
        getApplicationNameComponent(a?.applicationName, a?.appLatestApprovedReleaseId),
        getVersionComponent(
          a?.appLiveReleaseId, 
          a?.appLiveReleaseVersion, 
          ApplicationStatus.PUBLISHED
        ),
        getVersionComponent(
          a?.appLatestApprovedReleaseId, 
          a?.appLatestApprovedReleaseVersion, 
          a?.appLiveReleaseVersion === a?.appLatestApprovedReleaseVersion ? ApplicationStatus.PUBLISHED : ApplicationStatus.APPROVED
        ),
        getAppTypeComponent(a?.isInternal)
      ]
    }))
  }

  const getApplicationNameComponent = (name, releaseId) => {
    return (
      <span className="application-name-text" onClick={() => onVersionClicked(releaseId)}>
        {name}
      </span>
    )
  }

  const getVersionComponent = (releaseId, version, status) => {
    let title = null
    let icon = null
    let iconClass = null

    switch (status) {
      case ApplicationStatus.APPROVED:
        title = 'Not Published'
        icon = 'clock-o'
        iconClass = 'icon-warning'
        break
      case ApplicationStatus.PUBLISHED:
        title = 'Live'
        icon = 'check-circle-o'
        iconClass = 'icon-success'
        break
      default:
        title = '-'
        break
    }

    return (
      <div className="version-with-status-container">
        {!version || <span className="version-number" onClick={() => onVersionClicked(releaseId)}>v{version?.toFixed(1)}</span>}
        {version ? <IconTitle title={title} icon={icon} iconClass={iconClass} /> : '-'}
      </div>
    )
  }

  const getAppTypeComponent = (isInternal) => {
    if (isInternal) {
      return <div className="app-type app-type-internal"><span> Internal</span></div>
    }
    return <div className="app-type app-type-external"><span> External</span></div>
  }

  const onVersionClicked = (releaseId) => {
    history.push(`/admin/all-applications/${releaseId}`)
  }

  const getFilteredApps = () => {
    if (!appList || !Array.isArray(appList)) return []

    return appList.filter(i => {
      if (
        i?.applicationName?.toLowerCase().includes(filterText?.toLowerCase())
      ) {
        return true
      }
      return false
    })
  }

  const renderInnerComponent = () => {
    if (fetchingAppList) {
      return <LoadingBlock message="Loading..." />
    }
    if (errorFetchingAppList || !Array.isArray(appList)) {
      return <AppListErrorState />
    }
    if (appList?.length === 0) {
      return <AppListEmptyState />
    }
    return (
      <Fragment>
        <SectionHeader
          title="Applications"
          mainButtonText="Create App"
          mainButtonOnClick={() => history.push(`/admin/all-applications/0`)}
        />
        <SearchField
          placeholder="Search applications"
          value={filterText}
          onChange={(value) => setFilterText(value)}
        />
        <Table
          headers={headers}
          rows={generateTableRows()}
          disableHoverEffect={true}
        />
      </Fragment>
    )
  }

  return (
    <div className="all-applications-container">
      {renderInnerComponent()}
    </div>
  )
}

export default AllApplications



